import "moment/locale/pt-br";

import * as routes from "../../utils/contants/urls";
import * as urlsApi from "../../utils/contants/urlsApi";

import {
  buildCode,
  buildErroHandleItems,
  buildPagination,
  buildTimeFromSeconds,
  setHoursInDate
} from "../../helpers/sharedHelpers";
import { put, select, takeLatest } from "redux-saga/effects";

import API from "../../utils/API";
import { Types as MessageTypes } from "../ducks/messages";
import { Types } from "../ducks/documents";
import { history } from "../../utils/routes";
import { kindStages } from "../../locale/index";
import moment from "moment";

moment.locale("pt-BR");

const filterCandidates = payload => {
  const body = {
    nomeFuncionario: payload.nomeFuncionario,
    cpfList: payload.cpfList,
    idVagasList: payload.idVagasList,
    idLocaisList: payload.idLocaisList,
    dataInicioAtividade: payload.dateInitActivity,
    idStatusList: payload.idStatusList,
    numeroPagina: payload.NumeroPagina,
    quantidadeItens: payload.quantidadeItens,
    dataAdmissaoPrevista: payload.dataAdmissaoPrevista
  };

  return body;
};

function requestCandidadesFromVacancyList(body) {
  return API.put(
    `${urlsApi.REQUEST_CANDIDATESVACANCY_DOCS}`,
    body
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* getCandidatesVacancyDocs({ payload }) {
  console.log("payload", payload)
  try {
    let actualPage;
    if (payload && payload.firstPage) {
      actualPage = 1;
    } else {
      actualPage = payload.NumeroPagina || (yield select(getActualPage));
    }
    let actualItens = payload && payload.recoveredFilter && payload.quantidadeItens ? payload.quantidadeItens : 50;
    payload.quantidadeItens = actualItens;
    payload.NumeroPagina = actualPage;

    const { lista, paginacao } = yield requestCandidadesFromVacancyList(filterCandidates(payload));

    const candidates = {
      candidatos: lista?.candidatosNaEtapaList.map(e => ({
        id: e.id,
        cpf: e.cpf,
        idCandidatoNaEtapa: e.idCandidatoNaEtapa,
        idVaga: e.idVaga,
        nome: e.nome,
        statusCandidatoNaEtapa: e.statusCandidatoNaEtapa,
        tituloVaga: e.tituloVaga,
        dataAdmissaoPrevista: e.dataAdmissaoPrevista !== null ? e.dataAdmissaoPrevista : "-"
      })),
      candidatosPorVaga: lista?.candidatosNaEtapaPorVagaList.map(e => ({
        idVaga: e.idVaga,
        nomeVaga: e.nomeVaga,
        candidatesByVacancyList: e.candidatosNaEtapaList.map(c => ({
          id: c.id,
          cpf: c.cpf,
          idCandidatoNaEtapa: c.idCandidatoNaEtapa,
          idVaga: c.idVaga,
          nome: c.nome,
          statusCandidatoNaEtapa: c.statusCandidatoNaEtapa,
          tituloVaga: c.tituloVaga,
          dataAdmissaoPrevista: e.dataAdmissaoPrevista !== null ? e.dataAdmissaoPrevista : "-"
        })),
      }))
    };
    let candidatos;
    let candidatosPorVaga;
    //const hasMore = payload.firstPage ? true : lista?.candidatosNaEtapaList.length;
    const stateCandidateList = yield select(getStateCandidatesList);
    /* if (!payload.firstPage) {
      candidatos = stateCandidateList.candidatos.concat(candidates.candidatos);
      candidatosPorVaga = stateCandidateList.candidatosPorVaga.concat(candidates.candidatosPorVaga);
    }
    else {*/
    candidatos = candidates.candidatos;
    candidatosPorVaga = candidates.candidatosPorVaga;
    // }
    const AllCandidates = {
      candidatos: candidatos,
      candidatosPorVaga: candidatosPorVaga
    }

    const paginacaoNumber = { ...paginacao, page: payload.NumeroPagina }

    const pagination = buildPagination(
      paginacaoNumber,
      payload,
      AllCandidates.candidatos,
      stateCandidateList,
      50,
    )
    yield put({
      type: Types.CANDIDATES_VACANCYS_DOCS_SUCCESS,
      candidates: AllCandidates,
      pagination,

    });
  } catch (error) {
    yield put({ type: Types.CANDIDATES_VACANCYS_DOCS_FAIL, error });
  }
}

const getActualPage = state => state.documents?.page || 1;
const getStateCandidatesList = state => state.documents?.candidates;

function requestCandidadeFilesList(id) {
  return API.get(
    `${urlsApi.REQUEST_CANDIDATES_FILES}?Id=${id}`

  )
    .then(res => res.data)
    .catch(error => { throw error });
}

function* getCandidateFiles({ payload }) {
  try {
    const candidateDocs = yield requestCandidadeFilesList(payload.id);


    if (candidateDocs && candidateDocs.documentosEnviados.lenght == 0) {
      window.location.href = `${routes.DOCUMENTS_CANDIDATES}`;
    }



    const candidatesFiles =

    {
      nome: candidateDocs.nome,
      idCandidatoEtapa: candidateDocs.idCandidatoEmEtapa,
      statusEtapa: candidateDocs.statusEtapa,
      podeConfirmar: candidateDocs.podeConfirmar,
      podeEditar: candidateDocs.podeEditar,
      cpf: candidateDocs.cpf,
      idVaga :   candidateDocs.idVaga,
      nomeVaga :   candidateDocs.nomeVaga,

      filesList: candidateDocs.documentosEnviados ? candidateDocs.documentosEnviados.map(e => ({
        Id: e.id,
        url: e.url,
        nome: e.nome,
        status: e.status,
        instrucao: e.descricao,
        type: e.tipo
      })) : [],
      filesBaseList: candidateDocs.documentosPossiveisDeEnvio ? candidateDocs.documentosPossiveisDeEnvio.map(e => ({
        Id: e.id,
        descricao: e.descricao,
        nome: e.nome,
        tipoDocumento: e.tipoDocumento
      })) : [],

    };


    yield put({
      type: Types.CANDIDATE_FILES_SUCCESS,
      candidatesFiles

    });
  } catch (error) {
    yield put({ type: Types.CANDIDATE_FILES_FAIL, error });
  }
}


function requestSetStatusFile(payload) {
  return API.put(
    `${urlsApi.SET_CANDIDATES_FILES}`,
    { IdDocumento: payload.idDocumento, IdCandidatoEmEtapa: payload.idCandidatoEmEtapa, Status: parseInt(payload.status), messageParaCandidato: payload.message }
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* setStatusFiles({ payload }) {
  try {
    const candidateDocs = yield requestSetStatusFile(payload);

    window.location.href = `${routes.DOCUMENTS_LIST}/${payload.idCandidatoEmEtapa}`;

  } catch (error) {
    yield put({ type: Types.CANDIDATE_SET_STATUS_FILE_FAIL, error });
  }
}



function requestSetStatusStage(payload) {
  return API.get(
    `${urlsApi.DOCUMENTS_CONFIRM_STAGE}?idCandidatoEtapa=${payload.id}`
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* setStatusStage({ payload }) {
  try {
    const candidateDocs = yield requestSetStatusStage(payload);

    window.location.href = `${routes.DOCUMENTS_LIST}/${payload.id}`;
    window.location.href = `${routes.DOUBTS_LIST}/${payload.id}`;

  } catch (error) {
    yield put({ type: Types.CANDIDATE_SET_STATUS_STAGE_FAIL, error });
  }
}


function requestNewDocToCandidate(payload) {
  
  return API.put(   
    `${urlsApi.SET_DOCUMENT_CANDIDATE}`,
    {IdDocumento: payload.idDocumentoBase, IdCandidatoEmEtapa: payload.idCandidatoEmEtapa, messageParaCandidato: payload.message }, 
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });

}


function* setNewDocToCandidate({ payload }) {
  try {
    yield requestNewDocToCandidate(payload);
    window.location.href = `${routes.DOCUMENTS_LIST}/${payload.idCandidatoEmEtapa}`
    yield put({
      type: Types.CANDIDATE_FILES_SUCCESS,
    });
  } catch (error) {
    yield put({ type: Types.CANDIDATE_FILES_FAIL, error });
  }
}

function requestReleaseStageForCandidates(payload) {
  return API.put(
    `${urlsApi.RELEASE_STAGE_FOR_CANDIDATES}`, { ...payload }
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* releaseStageForCandidates({ payload }) {
  try {
    yield requestReleaseStageForCandidates(payload);

    yield put({
      type: Types.RELEASE_STAGE_FOR_CANDIDATES_SUCCESS,
    });
  } catch (error) {
    yield put({ type: Types.RELEASE_STAGE_FOR_CANDIDATES_FAIL, error });
  }
}

function requestReleaseCancellationForCandidates(payload) {
  return API.put(
    `${urlsApi.RELEASE_CANCELLATION_FOR_CANDIDATES}`, { ...payload }
  )
    .then(res => res.data)
    .catch(error => {
      throw error;
    });
}

function* releaseCancellationForCandidates({ payload }) {
  try {
    yield requestReleaseCancellationForCandidates(payload);

    yield put({
      type: Types.RELEASE_CANCELLATION_FOR_CANDIDATES_SUCCESS,
    });
  } catch (error) {
    yield put({ type: Types.RELEASE_CANCELLATION_FOR_CANDIDATES_FAIL, error });
  }
}


export function* watcherSaga() {
  yield takeLatest(Types.CANDIDATES_VACANCYS_DOCS_REQUEST, getCandidatesVacancyDocs);
  yield takeLatest(Types.CANDIDATE_FILES_REQUEST, getCandidateFiles);
  yield takeLatest(Types.CANDIDATE_SET_STATUS_FILE_REQUEST, setStatusFiles);

  yield takeLatest(Types.CANDIDATE_SET_STATUS_STAGE_REQUEST, setStatusStage);

  yield takeLatest(Types.CANDIDATE_INCLUDE_NEW_DOC_REQUEST, setNewDocToCandidate);

  yield takeLatest(Types.RELEASE_STAGE_FOR_CANDIDATES_REQUEST, releaseStageForCandidates);

  yield takeLatest(Types.RELEASE_CANCELLATION_FOR_CANDIDATES_REQUEST, releaseCancellationForCandidates);
}
